module.exports = __webpack_public_path__ + "img/laptop-information.e1520427.svg";